import React from "react";
import { IMG } from "@/lib/assets";

const founders = [
  {
    src: IMG.ramya,
    name: "Ramya Rajakumar",
    role: "Co-Founder & CEO",
    bio: "AI governance, data, and agile delivery expert who builds AI that actually works in the real world.",
  },
  {
    src: IMG.munique,
    name: "Munique Antunes",
    role: "Co-Founder & COO",
    bio: "Ex-Bradesco and 15-year executive coach who turns complex AI into plain, practical terms.",
  },
];

export const FoundersStrip = () => (
  <div id="about" data-testid="why-founders" className="relative mt-8 pt-7 border-t border-white/10">
    <span className="font-mono text-[11px] tracking-[0.22em] uppercase text-[var(--camel-soft)]/85">
      / About the founders
    </span>
    <h3 data-testid="why-founders-headline" className="font-serif font-medium text-white text-[28px] sm:text-[36px] leading-[1.1] mt-3 mb-6">
      Built by two women who know how to{" "}
      <span className="relative inline-block uppercase tracking-tight" style={{ color: "#E8CE95", fontWeight: 600, letterSpacing: "-0.02em" }}>
        deliver
        <span
          className="absolute left-0 right-0 -bottom-1 h-2 rounded-sm -z-0"
          style={{ background: "linear-gradient(90deg, #E8CE95 0%, #C79B55 60%, #E8CE95 100%)", opacity: 0.35 }}
        />
      </span>
      .
    </h3>
    <div className="grid md:grid-cols-2 gap-4">
      {founders.map((f, i) => (
        <div
          key={f.name}
          data-testid={`why-founder-${i}`}
          className="flex gap-5 items-center rounded-2xl border border-white/10 bg-white/[0.03] p-5"
        >
          <img
            src={f.src}
            alt={f.name}
            loading="lazy"
            className="w-36 h-[168px] sm:w-48 sm:h-56 shrink-0 rounded-2xl object-cover object-center ring-2 ring-[#E8CE95]/40"
          />
          <div>
            <div className="font-serif text-[20px] text-white leading-tight">{f.name}</div>
            <div className="font-mono text-[9.5px] tracking-[0.2em] uppercase text-white/50 mt-1">{f.role}</div>
            <p className="mt-2 text-[14px] leading-[1.55] text-white/70">{f.bio}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
);
